import React, { useMemo } from 'react'
import { useCanAccess } from '../../hooks/useCanAccess'
import { ListActions } from '../list-actions'
import { ListActionsWithPermissionProps } from './type'
import isBoolean from 'lodash/isBoolean'
import isUndefined from 'lodash/isUndefined'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import { useRecordContext } from 'react-admin'

const isBlocked = (config, record): boolean => {
  // if config is boolean
  if (isBoolean(config) || isNil(record) || isEmpty(record)) return config
  const { field, blockedIfValue } = config
  // if config with field and value
  if (isUndefined(field) || isUndefined(blockedIfValue)) return true
  return record[field] === blockedIfValue ? false : true
}

export const ListActionsWithPermission: React.FC<ListActionsWithPermissionProps> = ({
  hasCreate: hasCreateProps,
  hasExport: hasExportProps,
  hasPreview: hasPreviewProps,
  hasEdit: hasEditProps,
  hasShow: hasShowProps,
  hasList: hasListProps,
  ...props
}) => {
  const record = useRecordContext()
  const { isLoading, permission, error } = useCanAccess()
  const listActionProps = useMemo(
    () => ({
      hasCreate: isBlocked(hasCreateProps, record) && permission?.creatable,
      hasExport: isBlocked(hasExportProps, record) && permission?.exportable,
      hasPreview: isBlocked(hasPreviewProps, record) && permission?.readable,
      hasEdit: isBlocked(hasEditProps, record) && permission?.updatable,
      hasShow: isBlocked(hasShowProps, record) && permission?.readable,
      hasList: isBlocked(hasListProps, record) && permission?.readable,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(permission), JSON.stringify(record), isLoading, error],
  )
  if (isLoading || !permission) return null
  return <ListActions {...listActionProps} {...props} />
}
